import { useEffect, useRef, useState } from 'react'

/** Eases a number toward its new value whenever it changes. */
export const useAnimatedNumber = (target: number, duration = 550): number => {
    const [value, setValue] = useState(target)
    const current = useRef(target)

    useEffect(() => {
        const from = current.current

        if (from === target) return

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            current.current = target
            setValue(target)

            return
        }

        const start = performance.now()
        let frameId = 0

        const tick = (now: number) => {
            const t = Math.min(1, (now - start) / duration)
            const eased = 1 - Math.pow(1 - t, 3)
            const next = from + (target - from) * eased

            current.current = next
            setValue(next)

            if (t < 1) frameId = requestAnimationFrame(tick)
        }

        frameId = requestAnimationFrame(tick)

        return () => cancelAnimationFrame(frameId)
    }, [target, duration])

    return value
}
